export default __webpack_public_path__ + "static/media/210.6e4d0fd9.gif";